import React, { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import { uploadAuPostcode } from "../appSlice";
import Button from "../Shared/Button";

const PostcodeUpload = () => {
  const [fileName, setFileName] = useState("");
  const [isUploading, setIsUploading] = useState(false);

  const inputFileEl = useRef(null);

  const dispatch = useDispatch();

  const handleUpload = async () => {
    setIsUploading(true);
    const data = new FormData();
    data.append("postcodes", inputFileEl.current.files[0]);
    await dispatch(uploadAuPostcode(data));
    setIsUploading(false);
  };

  return (
    <div className="columns">
      <div className="column is-half">
        <p className="menu-label">Upload Australia postcode</p>
        <div className="file has-name is-boxed is-small is-centered is-fullwidth mb-4">
          <label className="file-label">
            <input
              ref={inputFileEl}
              className="file-input"
              type="file"
              name="postcodes"
              onChange={(e) => setFileName(e.target.files[0].name)}
            />
            <span className="file-cta is-radiusless has-text-centered">
              <span className="file-icon">
                <i className="fas fa-upload"></i>
              </span>
              <span className="file-label">Choose a file…</span>
            </span>
            {!isEmpty(fileName) && <span className="file-name is-radiusless">{fileName}</span>}
          </label>
        </div>
        <Button text="Upload" isLoading={isUploading} onClick={handleUpload} />
      </div>
    </div>
  );
};

export default PostcodeUpload;
